import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";
import { GET_PORCENTAJE_MAX_MONTO_AJUSTE } from "../../../data/graphQL/queries/PreLiquidacion/getPorcentajeMaxMontoAjuste";
import { GET_MAX_MONTO_AJUSTE_CP } from "../../../data/graphQL/queries/PreLiquidacion/getMaxMontoAjusteCP";

export const useGetPorcentajeMaxMontoAjuste = () => {
    const { data } = useQuery(GET_PORCENTAJE_MAX_MONTO_AJUSTE);
    const { data: dataCP } = useQuery(GET_MAX_MONTO_AJUSTE_CP);

    const porcentajeMaxMontoAjuste = useMemo(() => {
        return data?.porcentajeMaxMontoAjuste?.valorEsperado || null;
    }, [data]);

    const valorMaxMontoAjusteCP = useMemo(() => {
        return dataCP?.maxMontoAjusteCP?.valorEsperado || null;
    }, [dataCP]);

    return { porcentajeMaxMontoAjuste, valorMaxMontoAjusteCP };
}
